import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import {
  TabMenuContainer,
  TabMenuHeaderContainer,
  TabMenuHeader,
  TabMenuItemContainer,
  TabMenuItemDetails,
  EmptyElements,
  TabSearchContainer,
  NoteText,
  PopoverContainer,
  ClearAll,
  ElementNavWrapper,
} from './styles';
import { Icon, Input, Col, Popover, Select, Button, Badge } from 'antd';
import _ from 'underscore';
import EmptyElementsIllustration from '../../images/empty-elements.svg';
import HelpGuide from '../../components/HelpGuide';
import { FilterSvg } from '../../components/SidebarMenuIcons';

import { masterElements } from '../../utils/masterElements';
import { MASTER_ELEMENTS_TAB as trans } from './translationValues';

const NAMESPACES = [
  'FREE_HAND_TEXT_ELEMENTS',
  'FILLABLE_ELEMENTS',
  'BARCODE_MASTER_ELEMENTS',
  'LINE_MASTER_ELEMENTS',
  'SHAPES_MASTER_ELEMENTS',
  'MASTER_ELEMENTS_CATEGORIES',
  'MASTER_ELEMENTS_TAB',
  'FILLABLE_ELEMENTS_MAIN_CONTENT',
  'TABLE_ELEMENTS'
];

const { Option } = Select;

const MasterElementsTabDetails = (props) => {
  const { isEmailTemplate, currentBlockType = '' } = props;
  const { t, i18n } = useTranslation(NAMESPACES);
  const [initialLoader, setInitialLoader] = useState(true);
  const [searchKey, setSearchKey] = useState('');
  const [filterVisible, setFilterVisible] = useState(false);
  const [isSearchView, setIsSearchView] = useState(false);
  const [filteredElementsByCateg, setFilteredElementsByCateg] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [filterOption, setFilterOption] = useState('All');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [filteredElements, setFilteredElements] = useState([]);

  let elements = masterElements(t, i18n.language, currentBlockType);
  if (isEmailTemplate) {
    elements = elements.filter(el => el.categoryId !== 4);
  }

  useEffect(() => {
    setTimeout(() => {
      setInitialLoader(false);
    }, 400);
    // eslint-disable-next-line
  }, []);

  const getAllElements = () => {
    let allElements = [];
    elements.map(ele => {
      allElements = [...allElements, ...ele.elements];
    });
    return allElements;
  };

  const onSearch = useCallback(
    (val, categ) => {
      let allElements = getAllElements(elements);
      setIsSearchView(val.length > 0);
      let masterElements =
        categ === null
          ? allElements
          : selectedCategory?.categoryId
          ? filteredElementsByCateg?.elements
          : allElements;
      setFilteredElements([]);
      const filtered = masterElements.filter(element =>
        element.name.toLowerCase().includes(val.toLowerCase()),
      );
      setFilteredElements(filtered);
    },
    [selectedCategory, filteredElementsByCateg, elements],
  );

  const onClearSearch = selectedCateg => {
    setSearchKey('');
    setIsSearchView(false);
    if (selectedCateg?.categoryId) {
      seeAllByCategory(selectedCateg, '');
    }
  };

  const seeAllByCategory = (category, searchVal) => {
    const allElementsByCateg = JSON.parse(JSON.stringify(elements));
    setIsSearchView(false);
    let selectedEleByCateg = [];
    allElementsByCateg.map(ele => {
      if (category.categoryId === ele.categoryId) {
        selectedEleByCateg = ele;
        if (searchVal.length > 0) {
          selectedEleByCateg.elements = selectedEleByCateg.elements.filter(element =>
            element.name.toLowerCase().includes(searchVal.toLowerCase()),
          );
        }
      }
    });
    if (searchVal.length > 0) {
      setIsSearchView(true);
      setFilteredElements(selectedEleByCateg.elements);
    }
    setFilteredElementsByCateg(selectedEleByCateg);
    setFilterOption(category);
    setSelectedCategory(category);
  };

  const clearAll = () => {
    setSelectedCategory(null);
    setFilterVisible(false);
    setFilteredElementsByCateg([]);
    setFilterOption('All');
    searchKey.length > 0 && onSearch(searchKey, null);
  };

  const showCategories = () => {
    setFilterVisible(!filterVisible);
    let allCategories = [];
    elements.map(ele => {
      let category = {
        categoryId: ele.categoryId,
        categoryName: ele.categoryName,
      };

      allCategories = [...allCategories, category];
      setAllCategories(allCategories);
    });
  };

  const renderSearchBar = () => {
    return (
      <TabSearchContainer >
        <Input
          name="elementSearch"
          placeholder={t(
            `MASTER_ELEMENTS_TAB:${trans.SEARCH_ELEMENTS_PLACEHOLDER.key}`,
            trans.SEARCH_ELEMENTS_PLACEHOLDER.value,
          )}
          value={searchKey}
          onChange={e => setSearchKey(e.target.value)}
          onPressEnter={e => onSearch(e.target.value)}
          style={{ width: 200 }}
          prefix={<Icon type="search" />}
          autoComplete={'off'}
          suffix={
            <>
              {searchKey.length > 0 && (
                <Icon type="close" onClick={() => onClearSearch(selectedCategory)} />
              )}
              <Popover
                placement="bottomRight"
                title={t(
                  `MASTER_ELEMENTS_TAB:${trans.SEARCH_BY_CATEGORY_LABEL.key}`,
                  trans.SEARCH_BY_CATEGORY_LABEL.value,
                )}
                trigger="click"
                visible={filterVisible}
                onVisibleChange={() => {
                  showCategories();
                }}
                content={
                  <PopoverContainer>
                    <ClearAll onClick={() => clearAll()}>
                      {t(
                        `MASTER_ELEMENTS_TAB:${trans.CLEAR_ALL_FILTER_ACTION.key}`,
                        trans.CLEAR_ALL_FILTER_ACTION.value,
                      )}
                    </ClearAll>
                    <Select
                      showSearch
                      value={JSON.stringify(filterOption)}
                      style={{ width: 200 }}
                      placeholder={t(
                        `MASTER_ELEMENTS_TAB:${trans.SEARCH_BY_CATEGORY_PLACEHOLDER.key}`,
                        trans.SEARCH_BY_CATEGORY_PLACEHOLDER.value,
                      )}
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={value => setFilterOption(JSON.parse(value))}
                    >
                      <Option key="all" value={JSON.stringify('All')}>
                        {t(
                          `MASTER_ELEMENTS_TAB:${trans.ALL_CATEGORY_DROPDOWN_OPTION.key}`,
                          trans.ALL_CATEGORY_DROPDOWN_OPTION.value,
                        )}
                      </Option>
                      {allCategories.length > 0 &&
                        allCategories.map(data => (
                          <Option key={data.categoryId} value={JSON.stringify(data)}>
                            {data.categoryName}
                          </Option>
                        ))}
                    </Select>
                    <Button
                      type="primary"
                      onClick={() => [
                        setFilterVisible(false),
                        seeAllByCategory(filterOption, searchKey),
                      ]}
                    >
                      {t(
                        `MASTER_ELEMENTS_TAB:${trans.APPLY_FILTERS_BUTTON.key}`,
                        trans.APPLY_FILTERS_BUTTON.value,
                      )}
                    </Button>
                  </PopoverContainer>
                }
              >
                <Badge dot count={selectedCategory ? null : 0}>
                  <Icon component={FilterSvg} onClick={() => setFilterVisible(!filterVisible)} />
                </Badge>
              </Popover>
            </>
          }
        />
        {isSearchView &&
          (filteredElements?.length > 0 ? (
            <NoteText>
              {t(
                `MASTER_ELEMENTS_TAB:${trans.ELEMENTS_FOUND_COUNT.key}`,
                trans.ELEMENTS_FOUND_COUNT.value,
                { elementsCount: filteredElements?.length },
              )}
            </NoteText>
          ) : (
            renderEmptyView()
          ))}
      </TabSearchContainer>
    );
  };

  const renderEmptyView = () => (
    <EmptyElements>
      <div className="empty-illustration">
        <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
      </div>
      <div className="empty-txt">
        {t(
          `MASTER_ELEMENTS_TAB:${trans.EMPTY_ELEMENTS_LABEL.key}`,
          trans.EMPTY_ELEMENTS_LABEL.value,
        )}
      </div>
    </EmptyElements>
  );

  const tabHeaderView = category => {
    return (
      <Col>
        <TabMenuHeader className="categoryName">
          <h2>{category.categoryName}</h2>
        </TabMenuHeader>
      </Col>
    );
  };

  const renderElementsCard = (elementObj, category) => {
    const isSvg = elementObj?.element?.svgColors;
    let categoryElement = {
      id: elementObj.id,
      name: elementObj.name,
      thumbnail: elementObj.thumbnail,
      type: 'plain',
      elementDetails: elementObj.element,
      categoryName: category?.name,
      categoryId: category?.id,
      tags: elementObj.tags,
      elementType: elementObj.elementType,
      referenced: elementObj.referenced,
      isFillable: elementObj.isFillable,
    };
    if (elementObj.isText) {
      /// freehand text elements
      return (
        <TabMenuItemDetails key={elementObj.id} size="full">
          {props.renderElement(elementObj)}
        </TabMenuItemDetails>
      );
    }
    if (elementObj.element) {
      if (!_.isArray(elementObj.element)) {
        if (elementObj.element.blockElements) {
          categoryElement.type = 'colored';
        } else {
          const type = elementObj.element.type || elementObj.element.tagName;
          if (
            [
              'barcode',
              'image',
              'table',
              'textbox',
              // 'checkboxgroup',
              // 'radiobuttongroup',
              'signature',
            ].includes(type)
          ) {
            categoryElement.type = 'colored';
          }
        }
      } else {
        categoryElement.type = 'colored';
      }
    }
    return (
      <TabMenuItemDetails key={categoryElement.id} type="element">
        {props.renderElement(categoryElement, isSvg, true)}
      </TabMenuItemDetails>
    );
  };

  const renderBody = (data, isSearch = false) => {
    return (
      <TabMenuItemContainer isSearchView={isSearch}>
        {data.map(element => {
          const categoryDetails = {
            id: element.categoryId,
          };
          return renderElementsCard(element, categoryDetails);
        })}
      </TabMenuItemContainer>
    );
  };

  const renderBodyWithHeader = (data, index) => {
    return (
      <TabMenuHeaderContainer key={data.id} firstElement={index === 0}>
        {tabHeaderView(data)}
        {renderBody(data.elements)}
      </TabMenuHeaderContainer>
    );
  };

  return (
    !initialLoader && (
      <TabMenuContainer>
        <ElementNavWrapper>{renderSearchBar()}</ElementNavWrapper>
        {isSearchView
          ? renderBody(filteredElements, true)
          : selectedCategory && filteredElementsByCateg?.categoryId
          ? renderBodyWithHeader(filteredElementsByCateg, 0)
          : elements.map((data, index) => renderBodyWithHeader(data, index))}
        <HelpGuide />
      </TabMenuContainer>
    )
  );
};

export default withTranslation(NAMESPACES)(MasterElementsTabDetails);
